import * as React from 'react';
import { withNodeResizable } from '../shared/NodeResizable';
import { Portal } from '../shared/Portal';
import { createEmbedExtension } from '../shared/createEmbedExtension';
import { EmbedRendererProps } from '../shared/types';

const URL_REGEX = new RegExp('https?://share.descript.com/view/(\\w+)$');
export const ENABLED = [URL_REGEX];

export const Component = ({ url, ...rest }: EmbedRendererProps<any>) => {
  const newUrl = React.useMemo(() => {
    const regexResult = ENABLED[0].exec(url);
    if (regexResult && regexResult[1]) {
      const shareId = regexResult[1];
      return `https://share.descript.com/embed/${shareId}`;
    }
    return '';
  }, [url]);

  return (
    <Portal
      url={newUrl}
      title="Descript Embed"
      {...rest}
      fullHeight
      withMetadata
    />
  );
};

export default createEmbedExtension({
  regexp: [URL_REGEX],
  name: 'descript-embed',
  component: withNodeResizable(Component, {
    lockAspectRatio: true,
    defaultHeight: 500,
  }),
  addCommandOption: {
    title: 'Descript',
    description: 'Embed a Descript project.',
    searchTerms: ['embed', 'descript'],
    icon: 'logos:descript-icon',
  },
});
